
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  on: {
    pageInit(e, page) {
      const app = this.$app;
      const $$ = this.$;
      $$('#ipdPage .add-patient-btn').on('click', function (e) {
        e.preventDefault();
        app.popup.open('#ipdAddPatientPopup');
      });
      $$('#ipdSaveNewPatient').on('click', function () {
        var name = $$('#ipdNewPatientName').val().trim();
        var age = $$('#ipdNewPatientAge').val().trim();
        var gender = $$('#ipdAddPatientPopup input[name="ipd_new_patient_gender"]:checked').val();
        if (!name || !age) {
          app.dialog.alert('Please fill all patient details');
          return;
        }
        app.preloader.show();
        app.methods.authHeader();
        app.request({
          url: app.data.remoteUrl + 'patients',
          method: 'POST',
          data: {
            name: name,
            age: age,
            gender: gender
          },
          dataType: 'json',
          success: function (response) {
            app.preloader.hide();
            if (response.status) {
              var patient = response.data;
              var patientHtml = '<div class="item-input-wrap patient-radio-item">' + '<label class="radio">' + '<input type="radio" name="patient_id" value="' + patient.id + '" checked="">' + '<i class="icon-radio"></i>' + '</label>' + '<span class="patient-info"> ' + patient.name + ' / ' + patient.gender + ' / ' + patient.age + ' yrs</span>' + '</div>';
              $$('#ipdPage input[name="patient_id"]').prop('checked', false);
              $$('#ipdPage .no-patients-text').remove();
              $$('#ipdPage .add-patient-btn').parent().before(patientHtml);
              app.popup.close('#ipdAddPatientPopup');
              $$('#ipdNewPatientName').val('');
              $$('#ipdNewPatientAge').val('');
              $$('#ipdAddPatientPopup input[name="ipd_new_patient_gender"][value="Male"]').prop('checked', true);
              app.dialog.alert('Patient added successfully', 'Success');
            } else {
              var errorMsg = response.msg || 'Failed to add patient';
              if (response.errors) {
                var msgs = [];
                Object.keys(response.errors).forEach(function (key) {
                  msgs.push(response.errors[key].join(', '));
                });
                errorMsg = msgs.join('\n');
              }
              app.dialog.alert(errorMsg, 'Error');
            }
          },
          error: function (xhr) {
            app.preloader.hide();
            app.methods.requestError(xhr);
          }
        });
      });
      $$('#ipdPrescriptionDropArea').on('click', function (e) {
        if (!$$(e.target).closest('#ipdRemoveFileBtn').length) {
          $$('#ipdPrescriptionFile').click();
        }
      });
      $$('#ipdPrescriptionFile').on('change', function () {
        var file = this.files[0];
        if (file) {
          $$('#ipdUploadPlaceholder').hide();
          $$('#ipdUploadPreview').show();
          $$('#ipdPreviewFileName').text(file.name);
          if (file.type.startsWith('image/')) {
            var reader = new FileReader();
            reader.onload = function (e) {
              $$('#ipdPreviewImage').attr('src', e.target.result).show();
              $$('#ipdPreviewFileIcon').hide();
            };
            reader.readAsDataURL(file);
          } else {
            $$('#ipdPreviewImage').hide();
            $$('#ipdPreviewFileIcon').show();
          }
        }
      });
      $$('#ipdRemoveFileBtn').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $$('#ipdPrescriptionFile').val('');
        $$('#ipdUploadPreview').hide();
        $$('#ipdUploadPlaceholder').show();
        $$('#ipdPreviewImage').attr('src', '').hide();
        $$('#ipdPreviewFileIcon').show();
      });
      $$('#ipdForm').on('submit', function (e) {
        e.preventDefault();
        var selectedPatient = $$('#ipdPage input[name="patient_id"]:checked').val();
        if (!selectedPatient) {
          app.dialog.alert('Please select a patient');
          return;
        }
        var hospitalId = $$('#ipdPage input[name="hospital_id"]:checked').val();
        if (!hospitalId) {
          app.dialog.alert('Please select a hospital');
          return;
        }
        var formData = {
          patient_id: selectedPatient,
          hospital_id: hospitalId
        };
        app.preloader.show();
        app.methods.authHeader();
        app.request({
          url: app.data.remoteUrl + 'ipd-bookings',
          method: 'POST',
          data: formData,
          dataType: 'json',
          success: function (response) {
            app.preloader.hide();
            if (response.status) {
              app.dialog.alert(response.msg, 'Success', function () {
                app.views.main.router.navigate('/home/');
              });
            } else {
              app.dialog.alert(response.msg || 'Failed to submit request', 'Error');
            }
          },
          error: function (xhr) {
            app.preloader.hide();
            app.methods.requestError(xhr);
          }
        });
      });
    }
  },
  id: '03bf64eb34',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page" data-name="ipd" id="ipdPage">\n        <div class="navbar">\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title">IPD Booking</div>\n            </div>\n        </div>\n        <div class="page-content">\n            <form id="ipdForm">\n\n                <!--patient details section-->\n                <div class="card booking">\n                    <div class="card-content ptnt">\n                        <div class="content-header">Patient</div>\n                        <div class="card-content" id="ipdPatientListArea">\n                            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.patients.length, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.patients, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                            <div class="item-input-wrap patient-radio-item">\n                                <label class="radio">\n                                    <input type="radio" name="patient_id" value="';
              r += c(ctx_3.id, ctx_3);
              r += '" ';
              r += Template7Helpers.if.call(ctx_3, data_3 && data_3.first, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += 'checked=""';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '>\n                                    <i class="icon-radio"></i>\n                                </label>\n                                <span class="patient-info"> ';
              r += c(ctx_3.name, ctx_3);
              r += ' / ';
              r += c(ctx_3.gender, ctx_3);
              r += ' / ';
              r += c(ctx_3.age, ctx_3);
              r += ' yrs</span>\n                            </div>\n                            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                            ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            <p class="no-patients-text">No patients added yet. Add a patient to continue.</p>\n                            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                            <div style="margin-top: 10px;">\n                                <a href="#" class="link add-patient-btn" style="color: #1F8F60; font-weight: 600;">+ Add New Patient</a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <!--hospital selection section as cards-->\n                <div class="card booking">\n                    <div class="card-content ptnt">\n                        <div class="content-header"><sup class="requiredAst">*</sup> Select Hospital</div>\n                        <div class="card-content">\n                            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.hospitals.length, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            <div class="hospital-radio-list">\n                                ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.hospitals, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                <label class="hospital-radio-card">\n                                    <input type="radio" name="hospital_id" value="';
              r += c(ctx_3.id, ctx_3);
              r += '" ';
              r += Template7Helpers.if.call(ctx_3, data_3 && data_3.first, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += 'checked';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '>\n                                    <div class="hospital-card-inner">\n                                        <img class="hospital-card-img" src="';
              r += c(ctx_3.image_url, ctx_3);
              r += '" onerror="this.src=\'static/img/default_hospital.svg\'">\n                                        <div class="hospital-card-info">\n                                            <p class="hospital-card-name">';
              r += c(ctx_3.name, ctx_3);
              r += '</p>\n                                            ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.address, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                            <p class="hospital-card-address">';
                  r += c(ctx_4.address, ctx_4);
                  r += '</p>\n                                            ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                                        </div>\n                                        <span class="hospital-radio-indicator">\n                                            <span class="radio-outer-circle">\n                                                <span class="radio-inner-circle"></span>\n                                            </span>\n                                        </span>\n                                    </div>\n                                </label>\n                                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                            </div>\n                            ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            <p class="no-hospitals-text">No hospitals available.</p>\n                            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                        </div>\n                    </div>\n                </div>\n\n                <!--prescription upload section-->\n                <div class="card booking">\n                    <div class="card-content ptnt">\n                        <div class="content-header">Prescription (Optional)</div>\n                        <div class="card-content">\n                            <div class="prescription-upload-area" id="ipdPrescriptionDropArea">\n                                <div class="upload-placeholder" id="ipdUploadPlaceholder">\n                                    <div class="upload-icon">\n                                        <i class="material-icons" style="font-size: 42px; color: #2EB67D;">cloud_upload</i>\n                                    </div>\n                                    <p class="upload-text">Tap to upload prescription</p>\n                                    <p class="upload-hint">Supports JPG, PNG, PDF</p>\n                                </div>\n                                <div class="upload-preview" id="ipdUploadPreview" style="display: none;">\n                                    <div class="preview-content">\n                                        <i class="material-icons preview-icon" id="ipdPreviewFileIcon" style="font-size: 36px; color: #4CAF50;">insert_drive_file</i>\n                                        <img id="ipdPreviewImage" src="" style="display: none; max-width: 100%; max-height: 120px; border-radius: 8px;">\n                                        <p class="preview-filename" id="ipdPreviewFileName"></p>\n                                    </div>\n                                    <a href="#" class="link remove-file-btn" id="ipdRemoveFileBtn">\n                                        <i class="material-icons" style="color: #ff3b30;">close</i>\n                                    </a>\n                                </div>\n                                <input type="file" name="prescription" id="ipdPrescriptionFile" accept="image/*,.pdf" style="display: none;">\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <!--submit button-->\n                <div class="block">\n                    <button class="button button-fill button-large" type="submit">Submit Request</button>\n                </div>\n            </form>\n        </div>\n\n        <!-- Add New Patient Popup -->\n        <div class="popup" id="ipdAddPatientPopup">\n            <div class="view">\n                <div class="page">\n                    <div class="navbar">\n                        <div class="navbar-inner">\n                            <div class="left">\n                                <a href="#" class="link popup-close" style="color: #1F8F60;">\n                                    <i class="icon icon-back"></i>\n                                </a>\n                            </div>\n                            <div class="title">Add New Patient</div>\n                        </div>\n                    </div>\n                    <div class="page-content">\n                        <div class="list inline-labels no-hairlines-md" style="margin-top: 10px;">\n                            <ul>\n                                <li class="item-content item-input">\n                                    <div class="item-inner">\n                                        <div class="item-title item-label"><sup class="requiredAst">*</sup>Name</div>\n                                        <div class="item-input-wrap">\n                                            <input type="text" placeholder="Patient name" value="" id="ipdNewPatientName">\n                                            <span class="input-clear-button"></span>\n                                        </div>\n                                    </div>\n                                </li>\n                                <li class="item-content item-input">\n                                    <div class="item-inner">\n                                        <div class="item-title item-label"><sup class="requiredAst">*</sup>Age</div>\n                                        <div class="item-input-wrap">\n                                            <input type="number" placeholder="Age" id="ipdNewPatientAge" pattern="[0-9]*">\n                                            <span class="input-clear-button"></span>\n                                        </div>\n                                    </div>\n                                </li>\n                                <li class="item-content item-input d-none-after">\n                                    <div class="item-inner">\n                                        <div class="item-title item-label"><sup class="requiredAst">*</sup>Gender</div>\n                                        <div class="item-input-wrap">\n                                            <label class="radio">\n                                                <input type="radio" checked="" name="ipd_new_patient_gender" value="Male">\n                                                <i class="icon-radio"></i>\n                                            </label>\n                                            <span>Male</span>\n                                            <label class="radio">\n                                                <input type="radio" name="ipd_new_patient_gender" value="Female">\n                                                <i class="icon-radio"></i>\n                                            </label>\n                                            <span>Female</span>\n                                            <label class="radio">\n                                                <input type="radio" name="ipd_new_patient_gender" value="Other">\n                                                <i class="icon-radio"></i>\n                                            </label>\n                                            <span>Others</span>\n                                        </div>\n                                    </div>\n                                </li>\n                            </ul>\n                        </div>\n                        <div class="block">\n                            <button class="button button-fill button-large" type="button" id="ipdSaveNewPatient">Save Patient</button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  style: `
    /* Patient Radio List */
[data-f7-03bf64eb34] .patient-radio-item {
        padding: 10px 0;
        border-bottom: 1px solid #f0f0f0;
        display: flex;
        align-items: center;
    }
[data-f7-03bf64eb34] .patient-radio-item:last-of-type {
        border-bottom: none;
    }
[data-f7-03bf64eb34] .patient-info {
        font-size: 15px;
        color: #333;
        margin-left: 4px;
    }
[data-f7-03bf64eb34] .no-patients-text {
        font-size: 14px;
        color: #999;
        text-align: center;
        padding: 15px 0;
    }

    /* Hospital Radio Card List */
[data-f7-03bf64eb34] .hospital-radio-list {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
[data-f7-03bf64eb34] .hospital-radio-card {
        display: block;
        cursor: pointer;
        position: relative;
    }
[data-f7-03bf64eb34] .hospital-radio-card input[type="radio"] {
        position: absolute;
        opacity: 0;
        pointer-events: none;
    }
[data-f7-03bf64eb34] .hospital-card-inner {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        padding: 12px;
        border: 2px solid #e0e0e0;
        border-radius: 12px;
        background: #fff;
        transition: all 0.2s ease;
        position: relative;
    }
[data-f7-03bf64eb34] .hospital-radio-card input[type="radio"]:checked ~ .hospital-card-inner {
        border-color: #2EB67D;
        background: linear-gradient(135deg, #E7F6EF, #fff);
        box-shadow: 0 2px 8px rgba(46, 182, 125, 0.15);
    }
[data-f7-03bf64eb34] .hospital-card-img {
        width: 50px;
        height: 50px;
        border-radius: 10px;
        object-fit: cover;
        flex-shrink: 0;
        background: #f5f5f5;
        align-self: center;
    }
[data-f7-03bf64eb34] .hospital-card-info {
        flex: 1;
        min-width: 0;
    }
[data-f7-03bf64eb34] .hospital-card-name {
        font-size: 15px;
        font-weight: 600;
        color: #333;
        margin: 0;
        line-height: 1.3;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        word-break: break-word;
    }
[data-f7-03bf64eb34] .hospital-card-address {
        font-size: 12px;
        color: #888;
        margin: 4px 0 0;
        line-height: 1.4;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        word-break: break-word;
    }
[data-f7-03bf64eb34] .hospital-radio-indicator {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        align-self: center;
    }
[data-f7-03bf64eb34] .radio-outer-circle {
        width: 22px;
        height: 22px;
        border: 2px solid #ccc;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;
        background: #fff;
    }
[data-f7-03bf64eb34] .radio-inner-circle {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #2EB67D;
        transform: scale(0);
        transition: transform 0.2s ease;
    }
    /* When checked: show inner circle and change outer border */
[data-f7-03bf64eb34] .hospital-radio-card input[type="radio"]:checked ~ .hospital-card-inner .radio-outer-circle {
        border-color: #2EB67D;
    }
[data-f7-03bf64eb34] .hospital-radio-card input[type="radio"]:checked ~ .hospital-card-inner .radio-inner-circle {
        transform: scale(1);
    }
[data-f7-03bf64eb34] .hospital-radio-card input[type="radio"]:checked ~ .hospital-card-inner .hospital-card-name {
        color: #1F8F60;
    }
[data-f7-03bf64eb34] .no-hospitals-text {
        font-size: 14px;
        color: #999;
        text-align: center;
        padding: 15px 0;
    }

    /* Prescription Upload Area */
[data-f7-03bf64eb34] .prescription-upload-area {
        border: 2px dashed #d0d0d0;
        border-radius: 12px;
        padding: 20px;
        text-align: center;
        cursor: pointer;
        transition: all 0.2s ease;
        background: #fafafa;
        position: relative;
        min-height: 100px;
    }
[data-f7-03bf64eb34] .prescription-upload-area:active {
        border-color: #2EB67D;
        background: #E7F6EF;
    }
[data-f7-03bf64eb34] .upload-placeholder {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 6px;
    }
[data-f7-03bf64eb34] .upload-text {
        font-size: 15px;
        font-weight: 600;
        color: #333;
        margin: 0;
    }
[data-f7-03bf64eb34] .upload-hint {
        font-size: 12px;
        color: #999;
        margin: 0;
    }
[data-f7-03bf64eb34] .upload-preview {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
    }
[data-f7-03bf64eb34] .preview-content {
        display: flex;
        align-items: center;
        gap: 10px;
        flex: 1;
        min-width: 0;
    }
[data-f7-03bf64eb34] .preview-filename {
        font-size: 14px;
        font-weight: 500;
        color: #333;
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
[data-f7-03bf64eb34] .remove-file-btn {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f5f5f5;
        border-radius: 50%;
        flex-shrink: 0;
    }
`,
  styleScoped: true
};
    